<template>
  <div>
    <of-page mode="list-form" :leftWidth="300">
      <div slot="leftArea">
        <el-row :gutter="10" class="tree-search">
          <el-col :span="11">
            <el-input
              class="directory-search"
              size="mini"
              placeholder="输入关键字"
              v-model="searchValue"
              :disabled="isLoading"
            ></el-input>
          </el-col>
          <el-col :span="13" style="text-align: right">
            <div>
              <el-button
                v-access:add
                icon="el-icon-plus"
                size="mini"
                @click="addType"
                title="添加菜单"
                :disabled="isLoading"
                >菜单</el-button
              >
            </div>
          </el-col>
        </el-row>
        <el-tree
          :data="options"
          ref="dirTree"
          :draggable="false"
          v-loading="isLoading"
          node-key="id"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="selectNode"
        >
          <span class="directory-node" slot-scope="{ node, data }">
            <span class="tree-node-label">{{ data.text }}</span>
            <span class="directory-opear" v-show="currentSelectId === data.id">
              <i
                v-access:add
                class="el-icon-plus"
                title="添加目录"
                @click.stop="(n) => append(data, node)"
              ></i>
              <i
                v-access:delete
                v-if="showIcon"
                class="el-icon-delete"
                title="删除目录"
                @click.stop="(n) => remove(data, node)"
              ></i>
            </span>
          </span>
        </el-tree>
      </div>
      <div slot="content">
        <edit-form ref="editForm" @onOk="loadData()" />
      </div>
    </of-page>
  </div>
</template>
<script>
import OfPage from "@/components/base/of_page/of_page";
import api from "@/modules/zjrc/api";
import EditForm from "./edit.vue";

export default {
  name: "NewsTypeList",
  components: {
    OfPage,
    EditForm,
  },
  watch: {
    //关键字搜索
    searchValue(val) {
      this.$refs.dirTree.filter(val);
    },
  },
  data() {
    return {
      options: [],
      isLoading: false,
      currentSelectId: "",
      searchValue: "",
      showIcon: true,
    };
  },
  mounted() {
    const vm = this;
    vm.loadData();
  },
  methods: {
    remove(data, node) {
      const vm = this;
      vm.$confirm("确定要删除选中的栏目吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          id: data.id,
        };
        vm.isLoading = true
        api.DeleteNewsTypeById(param).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "删除成功",
              type: "success",
            })
            vm.$refs.editForm.onCancel()
            vm.loadData()
          }else{
            vm.$message({
                message: res.data.Message,
                type: "error",
              })
          }
        }).finally(()=>{
          vm.isLoading = false
        })
      });
    },
    append(data, node) {
      const vm = this;
      const param = {
        typeName: "新增栏目",
        parentId: data.id,
        parentName: data.text,
      };
      vm.isLoading = true;
      api
        .SaveNewsType(param)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            vm.loadData();
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .finally(() => {
          vm.isLoading = false;
        });
    },
    addType() {
      const vm = this;
      const param = {
        typeName: "新增栏目",
      };
      vm.isLoading = true;
      api
        .SaveNewsType(param)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            vm.loadData();
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .finally(() => {
          vm.isLoading = false;
        });
    },
    //节点筛选
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    //选择节点
    selectNode(data, n) {
      if (!n.expanded) {
        n.expanded = true;
      }
      this.currentSelectId = data.id;
      if (Array.isArray(data.children) && data.children.length > 0) {
        this.showIcon = false;
      } else {
        this.showIcon = true;
      }
      this.$refs.editForm.create(this.options, data.id);
    },
    loadData() {
      const vm = this;
      vm.isLoading = true;
      api
        .QueryNewsType()
        .then((res) => {
          if (res.data.Code == 0) {
            vm.options = res.data.Data;
          }
        })
        .finally(() => {
          vm.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  overflow: auto;
}

.directory-node {
  font-size: 14px;
  padding-right: 8px;
}

.directory-opear {
  position: absolute;
  right: 5px;
}

.directory-opear > i:first-child {
  margin-right: 5px;
}

.directory-search {
  margin-bottom: 10px;
}
</style>